import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DeleteSqsStatusInfoFromDynamoDbResponseInfo } from '@/coreInfrastructureModule/axios/generated/sqsAccessManage/api';
import { ISqsAccessManageRepository } from '@/coreInfrastructureModule/interfaces/ISqsAccessManageRepository';

/**
 * SQSをトリガーとする処理の進行状況一覧をDynamoDBから削除する
 */
export class DeleteSqsStatusInfoFromDynamoDbUseCase {
  /**
   * SQSをトリガーとする処理の進行状況一覧をDynamoDBから削除する
   * @param repository - SQSをトリガーとする処理の進行状況一覧をDynamoDBから取得する責務を負うクラス
   * @param requestId - 削除対象の情報が持つリクエストID
   */
  static async execute(
    repository: ISqsAccessManageRepository,
    requestId: string
  ): Promise<INetworkResult<DeleteSqsStatusInfoFromDynamoDbResponseInfo, Error>> {
    try {
      const result = await repository.delete(requestId);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
